//Material Group Codes
export const MATERIAL_GROUP_EQUIPMENT_CODE = '091';
export const MATERIAL_GROUP_LABOR_CODE = '092';
export const MATERIAL_GROUP_PRODUCTION_CODE = '093';
